import React from 'react';

import { Avatar, Box, HStack } from '@chakra-ui/react';
import { customTheme } from 'theme';

export const renderDomain = url => {
  const domain = new URL(url).hostname.replace(/^www\./, '');
  const faviconUrl = `https://www.google.com/s2/favicons?domain=${domain}`;
  return (
    <HStack align="flex-start" spacing={2}>
      <Box pt={1}>
        <Avatar src={faviconUrl} size="2xs" />
      </Box>
      <Box color={customTheme.colors.gray['250']} fontSize="sm">
        {domain}
      </Box>
    </HStack>
  );
};
